import script from "./ChannelsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ChannelsTable.vue?vue&type=script&setup=true&lang=js"

import "./ChannelsTable.vue?vue&type=style&index=0&id=0d8eb555&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d8eb555"]])

export default __exports__